import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import Breadcrumb from "../../App/Components/Navigation/Breadcrumbs/Breadcrumbs";
import { useSelector } from "react-redux";
import { selectCareersClientValue } from "../../App/State/Slices/SelectedCareersClientSlice";
import TabbedView from "../../App/Components/TabbedView/TabbedView";
import BingAccountDetailed from "./Components/Tabs/BingAccounts/BingAccountDetailed";
import { getBingAccount } from "./Components/Tabs/BingAccounts/BingAccountService";
import GoogleAccountDetailed from "./Components/Tabs/GoogleAccounts/GoogleAccountDetailed";
import {
  getGoogleAccount,
  getGoogleKeys,
} from "./Components/Tabs/GoogleAccounts/GoogleAccountService";
function ExternalAccountsTabs() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "80%",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    autocomplete: {
      width: "35%",
      paddingBottom: "20px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    hint: {
      position: "absolute",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      marginTop: "auto",
      marginBottom: "auto",
      marginLeft: "auto",
      marginRight: "auto",
      width: "300px",
      height: "300px",
      fontSize: "32px",
      textAlign: "center",
      color: "rgba(0,0,0,.6)",
    },
  }));

  const classes = useStyles();
  const selectedCareersClient = useSelector(selectCareersClientValue);
  const [bingAccount, setBingAccount] = useState({});
  const [googleAccount, setGoogleAccount] = useState({});
  const [reCaptchaKeys, setReCapthaKeys] = useState([]);
  const [geoKeys, setGeoKeys] = useState([]);

  useEffect(() => {
    if (selectedCareersClient !== null) {
      getBingAccount(selectedCareersClient.id).then((response) => {
        setBingAccount(response);
      });
      getGoogleAccount(selectedCareersClient.id).then((response) => {
        setGoogleAccount(response);
      });
      getGoogleKeys().then((response) => {
        var tempGeo = [];
        var tempReCaptcha = [];
        response.forEach((item) => {
          if (item.googleTypeId === 1) {
            tempReCaptcha.push(item);
          } else if (item.googleTypeId === 2) {
            tempGeo.push(item);
          }
        });
        setReCapthaKeys(tempReCaptcha);
        setGeoKeys(tempGeo);
      });
    }
  }, [selectedCareersClient]);

  const tabs = [
    {
      title: "Google",
      component: (
        <GoogleAccountDetailed
          googleAccount={googleAccount}
          setGoogleAccount={setGoogleAccount}
          geoKeys={geoKeys}
          reCaptchaKeys={reCaptchaKeys}
        />
      ),
    },
    {
      title: "Bing",
      component: (
        <BingAccountDetailed
          bingAccount={bingAccount}
          setBingAccount={setBingAccount}
        />
      ),
    },
  ];

  return (
    <>
      <div className="page-container">
        <Breadcrumb />
        <h1 className="page-title">
          {selectedCareersClient.clientName} External Accounts
        </h1>
        <div className={classes.root}>
          {selectedCareersClient === null ? (
            <div className={classes.hint}>
              <span>Select a client</span>
            </div>
          ) : (
            <TabbedView tabs={tabs} />
          )}
        </div>
      </div>
    </>
  );
}

export default ExternalAccountsTabs;
